import { render, staticRenderFns } from "./MessagingAnalytics.vue?vue&type=template&id=2c61e611&scoped=true"
import script from "./MessagingAnalytics.vue?vue&type=script&lang=js"
export * from "./MessagingAnalytics.vue?vue&type=script&lang=js"
import style0 from "./MessagingAnalytics.vue?vue&type=style&index=0&id=2c61e611&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c61e611",
  null
  
)

export default component.exports